<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-01-08 15:40:37
 * @LastEditors: sjq
 * @LastEditTime: 2024-01-09 17:41:07
 -->
<template>
  <van-popup v-model="visible" round position="bottom">
    <van-cascader
      v-model="cascaderValue"
      title="请选择所在地区"
      :options="options"
      @close="visible = false"
      @finish="onFinish"
      @change="onChange"
      :fieldNames="{
        text: 'name',
        value: 'code',
        children: 'children'
      }"
    />
  </van-popup>
</template>

<script>
import { Popup, Cascader } from 'vant'
import { getRegions } from '@/api/modules/payment/address'

export default {
  components: { 'van-popup': Popup, 'van-cascader': Cascader },
  props: {
    format: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      visible: false,
      fieldValue: '',
      cascaderValue: '',
      options: [],
      selectedOptions: []
    }
  },
  computed: {},
  watch: {
    visible() {
      if (this.visible) {
        console.log('object', this.defaultValue)
        if (this.defaultValue[2]) {
          this.selectedOptions = this.defaultValue.map(item => ({ code: item }))
          this.getRegions(1).then(res => {
            this.getRegions(2)
          })
          this.cascaderValue = this.defaultValue[2]
        }
      }
    }
  },
  created() {
    this.getRegions(0)
  },
  mounted() {},
  methods: {
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.visible = false
      this.fieldValue = selectedOptions.map(option => option.name).join(' / ')
      const { format } = this
      let model = {
        provinceName: selectedOptions[0].name,
        provinceCode: selectedOptions[0].code,
        cityName: selectedOptions[1].name,
        cityCode: selectedOptions[1].code,
        regionName: selectedOptions[2].name,
        regionCode: selectedOptions[2].code
      }
      this.$emit('on-select', { area: this.fieldValue, format, ...model })
    },
    onChange(data) {
      this.selectedOptions = data.selectedOptions
      this.getRegions(data.selectedOptions.length)
      // this.cascaderValue = data.value
    },
    getRegions(num) {
      let parentCode = null
      switch (num) {
        case 0:
          break
        case 1:
          parentCode = this.selectedOptions[0].code
          break
        case 2:
          parentCode = this.selectedOptions[1].code
          break
      }
      return getRegions({ parentCode }).then(res => {
        if (num !== 2) {
          res.forEach(item => (item.children = []))
        }
        switch (num) {
          case 0:
            this.options = res
            break
          case 1:
            var cityIndex = this.options.findIndex(item => item.code === this.selectedOptions[0].code)
            this.options[cityIndex].children = res
            this.$forceUpdate()
            break
          case 2:
            var cityIndex = this.options.findIndex(item => item.code === this.selectedOptions[0].code)
            var provinceIndex = this.options[cityIndex].children.findIndex(
              item => item.code === this.selectedOptions[1].code
            )
            this.options[cityIndex].children[provinceIndex].children = res
            this.$forceUpdate()
            break
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
